import { render, staticRenderFns } from "./SessionListAddNew.vue?vue&type=template&id=00a87090&"
import script from "./SessionListAddNew.vue?vue&type=script&lang=js&"
export * from "./SessionListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SessionListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports